import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const updateMeasuredCookie = createAction(`${actionKey}/UPDATE_COOKIE`, (cookieType, cookieDim, dims)=>({
        cookieType,
        cookieDim,
        dims
    }));
export const initializeMeasuredCookie = createAction(`${actionKey}/INIT`, (cookies)=>({
        cookies
    }));

//# sourceMappingURL=actions.js.map